'use client'

import { ENV } from '@/lib/constants/env'
import { useEffect } from 'react'

export function DynamicFavicon() {
  useEffect(() => {
    const isDevelopment = process.env.ENV === ENV.DEV

    if (isDevelopment) {
      // Remove existing favicon links
      const existingLinks = document.querySelectorAll('link[rel*="icon"]')
      existingLinks.forEach((link) => {
        link.remove()
      })

      // Set gray favicon for development
      const link = document.createElement('link')
      link.rel = 'icon'
      link.type = 'image/png'
      link.href = '/favicon-gray.png'
      document.head.appendChild(link)
    }
  }, [])

  return null
}
